export default __webpack_public_path__ + "static/media/developer.50172522.jpg";